import { BarChart, SkeletonLoader } from 'components';

import './InsuredEmployeesChart.scss';
import { ChartDataPoint } from './InsuredEmployeesChart.types';

interface InsuredEmployeesChartUiProps {
  isLoading: boolean;
  isError: boolean;
  data: ChartDataPoint[];
  onRetry: () => void;
}

export default function InsuredEmployeesChartUi({
  isLoading,
  isError,
  data,
  onRetry,
}: InsuredEmployeesChartUiProps) {
  if (isLoading) {
    return (
      <div className="insured-employees-chart">
        <SkeletonLoader height={300} />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="insured-employees-chart insured-employees-chart--error">
        <p>Failed to load chart data.</p>
        <button onClick={onRetry} className="p-button p-button-outlined">
          Retry
        </button>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="insured-employees-chart insured-employees-chart--empty">
        <p>No data available for this period.</p>
      </div>
    );
  }

  return (
    <div className="insured-employees-chart">
      <h3 className="insured-employees-chart__title">Insured Employees by Month</h3>
      <BarChart
        id="insured-employees-bar-chart"
        data={data}
        className="insured-employees-chart__chart"
      />
    </div>
  );
}
